const CSS = `
.react-comment-identity-skeleton{display:flex;align-items:flex-start;margin-bottom:1rem;}
.react-comment-identity-skeleton .rcis-avatar{flex:0 0 44px;width:44px;height:44px;border-radius:50%;margin-right:0.85rem;}
.react-comment-identity-skeleton .rcis-fields{flex:1;min-width:0;}
.react-comment-identity-skeleton .rcis-input{height:2.4rem;border-radius:1.25rem;margin-bottom:0.75rem;}
.react-comment-identity-skeleton .rcis-input.half{width:50%;}
.react-comment-identity-skeleton .rcis-shimmer{
  background:linear-gradient(90deg,#ececec 0%,#f7f7f7 50%,#ececec 100%);
  background-size:200% 100%;
  animation:reactCommentIdentitySkeletonShimmer 1.2s ease-in-out infinite;
}
@keyframes reactCommentIdentitySkeletonShimmer{
  0%{background-position:200% 0;}
  100%{background-position:-200% 0;}
}
`;

export default function CommentIdentitySkeleton() {
  return (
    <>
      <style>{CSS}</style>
      <div className="react-comment-identity-skeleton" aria-hidden="true">
        <div className="rcis-avatar rcis-shimmer" />
        <div className="rcis-fields">
          <div className="rcis-input half rcis-shimmer" />
          <div className="rcis-input half rcis-shimmer" />
        </div>
      </div>
    </>
  );
}
